var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.699,
    height: 14.158,
    viewBox: "0 0 15.699 14.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_like_837131",
    transform: "translate(0 -25.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M4.7,240.141c-.012-1.058-.013-2.116-.013-3.174s0-2.116.013-3.173c0,.141,0-.528.013-.964H.8a.732.732,0,0,0-.733.431c-.023.048-.044.1-.065.15v6.676a2.146,2.146,0,0,0,.186.316.629.629,0,0,0,.5.215c1.34,0,2.68,0,4.02,0C4.7,240.388,4.7,240.189,4.7,240.141Z",
    transform: "translate(0 -201.315)",
    fill: "#373334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M191.29,31.413a1.128,1.128,0,0,0-.718-.851,2,2,0,0,0-.638-.1c-1.151-.009-2.3,0-3.452,0-.148,0-.153-.009-.13-.152.071-.42.132-.841.215-1.259a3.18,3.18,0,0,0-.063-1.677c-.17-.494-.362-.981-.547-1.47a.98.98,0,0,0-.557-.6,1.745,1.745,0,0,0-1.553.047.854.854,0,0,0-.5.823c.015.541.019,1.082.041,1.623a.884.884,0,0,1-.12.5c-.417.717-.821,1.441-1.257,2.147a12.069,12.069,0,0,1-.772,1.03.412.412,0,0,1-.031.035v1.464q0,2.771-.016,5.541a2.1,2.1,0,0,0,1.172.326c1.965-.012,3.929-.005,5.894-.005a3.193,3.193,0,0,0,1.009-.129,1.55,1.55,0,0,0,1.117-1.406,1.765,1.765,0,0,0-.086-.768.169.169,0,0,1,.035-.131,1.722,1.722,0,0,0,.385-1.162,1.862,1.862,0,0,0-.1-.445.182.182,0,0,1,.029-.2,1.6,1.6,0,0,0,.383-1.058,3.7,3.7,0,0,0-.11-.559c-.009-.045-.016-.11.009-.137a1.675,1.675,0,0,0,.389-.82.094.094,0,0,1,.021-.031v-.432C191.32,31.51,191.3,31.462,191.29,31.413Z",
    transform: "translate(-175.634 0)",
    fill: "#373334"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlike);
export default __webpack_public_path__ + "static/media/unlike.86954524eaa163dce8c67e4d819c6f78.svg";
export { ForwardRef as ReactComponent };